import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "slug"]

  connect() {
    this.dirty = this.slugTarget.value.length > 0
  }

  sync() {
    if (this.dirty) return
    this.slugTarget.value = this.slugify(this.sourceTarget.value)
  }

  markDirty() {
    this.dirty = true
  }

  slugify(value) {
    return value
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
  }
}
